module.exports = __webpack_public_path__ + "img/admin-activate-btn.107bc74d.png";